module.exports = __webpack_public_path__ + "static/media/elearning.d7a52fdf.png";